{
  "global": {
    "backToHome": "返回首页",
    "errors": {
      "unhandledError": "未处理错误",
      "serverError": "服务器错误",
      "accessDenied": "访问被拒绝"
    }
  },
  "header": {
    "logoAlt": "CIM Bank - 瑞士私人银行",
    "btnLogout": "登出",
    "btnMessages": "消息",
    "btnRegistrations": "我的注册"
  },
  "footer": {
    "copyright": "© CIM Banque SA - Geneva, Lugano, Wollerau - Switzerland",
    "contactFormLabel": "联系表",
    "contactFormSubtitle": "请使用我们的联系表与我们的专员联系。我们很乐意帮助您！",
    "relationshipManagerLabel": "我的客户经理",
    "contactHours": "周一至周五，上午 08:30 至下午 06:30 (GMT+1)。",
    "contactPhone": "联系电话 +41 (0)58 225 50 50"
  },
  "modal": {
    "confirmButton": "确认",
    "cancelButton": "取消",
    "remark": "评论"
  },
  "attachment": {
    "fileNoName": "未命名文件",
    "errors": {
      "noMultipleFilesAllowed": "一次只能上传一个文件",
      "allowedTypes": "不支持的媒体类型或文件太大 (PDF/PNG)",
      "unhandledError": "检索文档时发生错误。 请检查文件大小（最大 8MB）并重试。"
    }
  },
  "gender": {
    "gender": "性别",
    "male": "男性",
    "female": "女性",
    "genderError": "性别为必填项"
  },
  "maritalStatusEnum": {
    "single": "单身",
    "married": "已婚",
    "divorced": "离婚",
    "widower": "丧偶",
    "civilUnion": "非婚姻性民事结合"
  },
  "counterpartyOperationTypeEnum": {
    "import": "进口",
    "export": "出口",
    "intermediation": "中介",
    "fees": "费用",
    "logisticsAndTransport": "物流与运输",
    "other": "其他"
  },
  "counterpartyCashFlowTypeEnum": {
    "incoming": "入账",
    "outgoing": "出账"
  },
  "signatureTypeEnum": {
    "signature": "签名",
    "signatureIndividual": "个人签名",
    "signatureCollective": "集体签名",
    "none": "无"
  },
  "validation": {
    "onlyChars": "该字段只能包含字符或数字"
  },
  "messages": {
    "messagesDialogTitle": "我的留言",
    "messageBy": "经过 {username}",
    "messageOn": "于 {date}",
    "messageSeen": "信息查阅人 {username} 于 {date}",
    "addMessage": "输入消息...",
    "addAttachment": "添加附件",
    "submit": "提交"
  },
  "login": {
    "email": "电子邮件",
    "btnRequestAccess": "获取安全链接",
    "openAccount": "开立帐户",
    "description": "我们将向您发送一封带有链接的电子邮件，通过该链接您可以安全地访问我们的平台。",
    "successMessage": "请检查您的电子邮件并使用安全链接进入。",
    "errors": {
      "invalidToken": "该链接无效。 请输入您的电子邮件地址，我们将向您发送一封带有链接的电子邮件，通过该链接您可以安全地访问我们的平台。",
      "genericError": "发生了错误。 请稍后重试。",
      "email": "电子邮件为必填项",
      "emailInvalid": "电子邮件必须有效",
      "noRecipientFound": "未找到此电子邮件"
    }
  },
  "open": {
    "btnBack": "后退",
    "btnNext": "下一个",
    "btnSubmit": "提交",
    "yes": "是",
    "no": "否",
    "tabs": {
      "accountType": "帐户类型",
      "individual": {
        "contactInformation": "个人信息",
        "additionalInformation": "附加信息",
        "confirmation": "确认"
      },
      "company": {
        "companyInformation": "公司信息",
        "contactInformation": "个人信息",
        "additionalInformation": "附加信息",
        "confirmation": "确认"
      }
    },
    "accountType": {
      "title": "选择您的账户类型",
      "subtitle": "让我们开始吧！ 请选择您想要开设的账户类型。",
      "optionIndividual": "个人账户",
      "optionIndividualInformation": "开户费用 <span class=\"cim-pink\">90</span> CHF/EUR/USD",
      "optionCorporate": "企业账户",
      "optionCorporateInformation": "开户费用 <span class=\"cim-pink\">500</span> CHF/EUR/USD",
      "warningPotential": ""
    },
    "individual": {
      "contactInformation": {
        "title": "填写您的个人信息和联系方式",
        "firstName": "名",
        "middleName": "中间名",
        "lastName": "姓氏",
        "email": "电子邮件",
        "repeatEmail": "重复电子邮件",
        "mobilePhone": "手机号码",
        "repeatMobilePhone": "重复手机号码"
      },
      "additionalInformation": {
        "title": "填写附加信息",
        "birthDate": "出生日期",
        "cityOfBirth": "出生城市",
        "countryOfBirth": "出生国家",
        "countryOfResidence": "居住国家",
        "nationality": "国籍",
        "preferredLanguage": "首选语言"
      },
      "confirmation": {
        "greetings": "谢谢你!",
        "messageInvited": "我们已向您发送了一封电子邮件，其中包含完成您的开户请求的进一步说明。 请点击电子邮件中的链接来定义您的密码并连接到 MyCIM。 如果没有，请检查您的垃圾邮件箱。",
        "message": "客户经理将很快与您联系，并开始开户流程。"
      },
      "errors": {
        "firstName": "名字是必填项",
        "lastName": "姓氏为必填项",
        "email": "电子邮件为必填项",
        "emailInvalid": "电子邮件必须有效",
        "emailsDifferent": "电子邮件必须匹配",
        "mobilePhone": "手机号码为必填项且必须有效 (i.e. +41XXXXXXXXX)",
        "mobilePhonesDifferent": "手机号码必须一致",
        "birthDate": "出生日期为必填项且必须有效",
        "birthDateFuture": "出生日期不能晚于今天",
        "cityOfBirth": "出生城市为必填项",
        "countryOfBirth": "出生国家/地区为必填项",
        "countryOfResidence": "居住城市为必填项",
        "nationality": "国籍为必填项",
        "preferredLanguage": "首选语言为必填项"
      }
    },
    "company": {
      "companyType": {
        "domiciliaryTitle": "非经营性公司",
        "domiciliarySubtitle": "持有参股或资产。",
        "operatingTitle": "运营公司",
        "operatingSubtitle": "提供服务或进行贸易。",
        "otherTitle": "其他结构",
        "otherSubtitle": "信托、基金会或协会、保险。"
      },
      "roleInCompany": {
        "noRole": "无职能",
        "beneficial": "受益人",
        "shareholder": "股东",
        "signatory": "签署人",
        "introducingPartner": "介绍人公司",
        "director": "董事"
      },
      "companyInformation": {
        "title": "选择您的公司类型",
        "companyName": "公司名称",
        "companyTypeRemark": "非经营性公司理由",
        "incorporationCountry": "成立国家",
        "contactTheBank": "请联系银行以继续您的开户程序"
      },
      "contactInformation": {
        "title": "填写您自己的个人信息",
        "info": "请提供您的联系信息，以便我们与您联系",
        "firstName": "名",
        "lastName": "姓氏",
        "role": "你在公司的职能是什么？",
        "cimBanqueCustomer": "您是 CIM 银行客户吗？",
        "accountNumber": "您的帐号是多少？",
        "howHeard": "您是如何听说过 CIM 银行的？"
      },
      "additionalInformation": {
        "title": "填写您自己的联系方式",
        "email": "电子邮件",
        "repeatEmail": "重复电子邮件",
        "mobilePhone": "手机号码",
        "repeatMobilePhone": "重复手机号码",
        "preferredLanguage": "首选语言"
      },
      "confirmation": {
        "greetings": "谢谢你！",
        "messageInvited": "我们已向您发送了一封电子邮件，其中包含完成您的开户请求的进一步说明。 请点击电子邮件中的链接来定义您的密码并连接到 MyCIM。 如果没有，请检查您的垃圾邮件箱。",
        "message": "客户经理将很快与您联系，并开始开户流程。"
      },
      "errors": {
        "companyName": "公司名称为必填项",
        "incorporationCountry": "公司成立国家/地区为必填项",
        "role": "职能为必填项",
        "alreadyCustomer": "此字段是必填字段",
        "accountNumber": "帐号为必填项",
        "firstName": "名字是必填项",
        "lastName": "姓氏为必填项",
        "email": "电子邮件为必填项",
        "emailInvalid": "电子邮件必须有效",
        "emailsDifferent": "电子邮件必须匹配",
        "mobilePhone": "手机号码为必填项且必须有效 (i.e. +41XXXXXXXXX)",
        "mobilePhonesDifferent": "手机必须匹配",
        "preferredLanguage": "首选语言为必填项",
        "companyTypeRemark": "理由为必填项"
      }
    }
  },
  "register": {
    "btnBack": "返回",
    "btnPrevious": "上一页",
    "btnCancel": "取消",
    "btnNext": "下一步",
    "btnContinue": "继续",
    "btnSubmit": "提交",
    "btnSave": "保存",
    "yes": "是",
    "no": "否",
    "tabs": {
      "individualAccountUsage": "账户目的",
      "individualInformation": "个人信息",
      "familyAndJob": "家庭与工作",
      "contract": "合同",
      "yourDocuments": "您的文件",
      "companyAccountUsage": "账户目的",
      "companyInformation": "公司信息",
      "companyStructure": "公司架构",
      "companyTransaction": "交易信息",
      "companyCounterparties": "交易对手",
      "underReview": "审核中",
      "refused": "拒绝",
      "initialDeposit": "初始资金存入"
    },
    "prospectSelection": {
      "title": "MyCIM 待注册",
      "continue": "下一步",
      "openAnotherAccount": "开设另一个账户"
    },
    "individualAccountUsage": {
      "title": "选择 {displayName} 帐户的用途",
      "accountUsages": {
        "savingsAndInvestments": "储蓄和投资",
        "currentAccount": "活期账户",
        "other": "其他说明"
      }
    },
    "companyAccountUsage": {
      "title": "选择 {displayName} 帐户的用途",
      "accountUsages": {
        "commercialActivity": "商业活动",
        "savingsAndInvestments": "储蓄和投资",
        "currentAccount": "活期账户",
        "other": "其他说明"
      }
    },
    "individualInformation": {
      "title": "填写 {displayName} 账户的个人详细信息",
      "subtitle": "亲爱的{username}，我们需要您回答以下问题",
      "addressLine1": "地址",
      "zipCode": "邮政编码",
      "city": "城市",
      "residenceCountryIsoCode": "居住国家",
      "passportNumber": "护照号",
      "passportExpirationDate": "护照有效期",
      "taxationCountryIsoCode": "征税国家",
      "tin_number": "TIN 编号",
      "hasTinNumber": "我没有 TIN 号码",
      "relationWithUSA": "与美国的关系",
      "isLinkedToUnitedStates": "您是否和美国有关系？",
      "hasUSPassportOrGreenCard": "您有美国护照或绿卡吗？",
      "hasSpentSubstantialTimeInUS": "您是否曾在美国停留超过 90 天？",
      "isUSResidentForAnyOtherReason": "您在美国拥有房地产吗？",
      "errors": {
        "addressLine1": "地址为必填项",
        "zipCode": "邮政编码为必填项",
        "city": "城市为必填项",
        "passportNumber": "护照号码为必填项",
        "passportExpirationDate": "P护照有效期必须有效",
        "passportExpirationDateOutdated": "该日期必须大于今天的日期",
        "residenceCountryIsoCode": "国家/地区为必填项",
        "taxationCountryIsoCode": "征税国家为必填项",
        "tinNumber": "TIN 号码为必填项",
        "isLinkedToUnitedStates": "美国 相关字段为必填项",
        "hasUSPassportOrGreenCard": "请选择一个选项",
        "hasSpentSubstantialTimeInUS": "请选择一个选项",
        "isUSResidentForAnyOtherReason": "请选择一个选项"
      }
    },
    "individualFamily": {
      "family": "{displayName} 的家庭成员",
      "maritalStatus": "婚姻状况",
      "spouse": "配偶/伴侣",
      "needJointAccount": "我需要一个联名账户",
      "children": "孩子们",
      "addChild": "添加一个孩子",
      "job": "{displayName} 的职位",
      "roleLabel": "工作职位 1/2",
      "jobLabel": "工作职位 2/2",
      "workplaceCountry": "工作国家/地区",
      "firstName": "名",
      "lastName": "姓氏",
      "errors": {
        "maritalStatus": "婚姻状况为必填项",
        "job": "工作为必填项",
        "workplaceCountryIsoCode": "工作地点为必填项",
        "partnerFirstName": "名字为必填项",
        "partnerLastName": "姓氏为必填项"
      }
    },
    "individualInProgressModal": {
      "title": "感谢您的信息",
      "subtitle": "您的数据已成功保存",
      "message": "请确保您的所有个人详细信息均正确无误，然后再继续，因为在下一步中您将无法更改它们"
    },
    "individualContract": {
      "title": "合同、条款和条件",
      "subtitle": "尊敬的 {username}，您即将签署您的合同。请花些时间阅读合约。",
      "openAndRead": "打开并阅读我的合同(草稿)",
      "contractAgreement": "我已阅读并同意我的合同",
      "termsAgreement": "我已经阅读并同意 CIM 银行的<a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/06_general-terms-and-conditions-en.pdf\">条款和条件</a>",
      "feesAgreement": "我已经阅读并同意 CIM 银行的<a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/zh/fees-for-private-accounts\">费用和佣金</a>",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "我已阅读并同意 <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/special_risks_security_trading.pdf\">金融工具交易涉及的风险</a>",
      "errors": {
        "contractAgreement": "此字段是必填字段",
        "termsAgreement": "此字段是必填字段",
        "feesAgreement": "此字段是必填字段",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "此字段是必填字段"
      }
    },
    "individualDocuments": {
      "title": "上传 {displayName} 的文档",
      "certificateOfResidence": "居住证明*",
      "certificateOfResidenceSubtitle": "拖放或单击以上传该持卡人的<span class='document-subtitle-string'>居住证明*</span>",
      "passport": "护照",
      "passportSubtitle": "拖放或单击以上传该持卡人的<span class='document-subtitle-string'>护照</span>",
      "datedLess": "*由政府主管部门在过去 12 个月内签发 - 请注意，我们不接受水电煤账单和银行对账单",
      "errors": {
        "allowedTypes": "仅允许使用图像或 PDF",
        "unhandledError": "检索文档时发生错误。 请检查文件大小（最大 8MB）并重试。"
      }
    },
    "companyInformation": {
      "title": "填写您的公司信息 {displayName}",
      "addressLine1": "地址",
      "addressLine2": "",
      "zipCode": "邮政编码",
      "city": "城市",
      "residenceCountryIsoCode": "国家",
      "website": "网站",
      "shareCapital": "股本",
      "shareCapitalCurrencyIsoCode": "货币",
      "dateOfIncorporation": "注册成立日期",
      "countryOfIncorporation": "公司成立国家/地区",
      "roleLabel": "经营活动 1/2",
      "activityId": "经营活动 2/2",
      "activityRemark": "活动说明",
      "hasBalanceSheetFinancialStatement": "公司有经过审计的资产负债表吗？",
      "hasExternalAccounting": "公司有外部会计吗？",
      "hasPhysicalOffice": "该公司在{countryName}有实体办事处吗？",
      "officeCountryIsoCode": "办事处所在国家/地区",
      "numberOfEmployees": "办事处员工人数",
      "hasEmployeesInPlaceOfIncorporation": "该公司在{countryName}有员工吗？",
      "hasDirectorInPlaceOfIncorporation": "该公司在{countryName}有一名董事？",
      "holdAnOperatingCompany": "该公司为一家运营公司？",
      "hasReadAndAgreeWithTermsAndConditions": "我已经阅读并同意 CIM 银行的<a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/2021_mycim_general-terms-and-conditions-en.pdf\">条款和条件</a>",
      "hasReadAndAgreeWithFeesAndCommissions": "我已经阅读并同意 CIM 银行的<a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/fees-for-company-accounts\">费用和佣金</a>",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "我已阅读并同意 <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/docs/default-source/pdf/special_risks_security_trading.pdf\">金融工具交易涉及的风险</a>",
      "errors": {
        "addressLine1": "地址为必填项",
        "zipCode": "邮政编码为必填项",
        "city": "城市为必填项",
        "residenceCountryIsoCode": "国家/地区为必填项",
        "shareCapital": "股本为必填项",
        "shareCapitalCurrencyIsoCode": "货币为必填项",
        "dateOfIncorporation": "公司成立日期为必填项且必须有效",
        "pastDateOfIncorporation": "成立日期必须早于今天",
        "countryOfIncorporation": "公司成立国家/地区为必填项",
        "officeCountryIsoCode": "办事处所在国家/地区为必填项",
        "numberOfEmployees": "员工人数为必填项",
        "activityId": "经营活动为必填项的",
        "activityRemark": "如果您选择“其他”，经营活动的描述是必填项",
        "hasBalanceSheetFinancialStatement": "此字段是必填字段",
        "hasExternalAccounting": "此字段是必填字段",
        "hasPhysicalOffice": "此字段是必填字段",
        "hasEmployeesInPlaceOfIncorporation": "此字段是必填字段",
        "hasDirectorInPlaceOfIncorporation": "此字段是必填字段",
        "hasReadAndAgreeWithTermsAndConditions": "此声明为强制性声明",
        "hasReadAndAgreeWithFeesAndCommissions": "此声明为强制性声明",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "此声明为强制性声明",
        "holdAnOperatingCompany": "此字段是必填字段"
      }
    },
    "companyStructure": {
      "signatory": "签署人",
      "ubo": "最终受益人",
      "ownershipTotalTitle": "所有权总和",
      "ownershipTotalWarning": "所有权总和应等于100%",
      "ownershipTitle": "所有权",
      "noUBO": "未添加最终受益人",
      "noSignatories": "未添加签名者",
      "addNewEntity": "添加最终受益人 或签字人",
      "incompleteRelatedEntites": "至少有一名最终受益人或签字人不完整",
      "title": {
        "companyStructure": "公司结构",
        "relativeEntitySelection": "公司相关人员",
        "relativeEntityBeneficialOwnerAdd": "为 {displayName} 添加最终受益所有人 (UBO)",
        "relativeEntityBeneficialOwnerEdit": "修改 {displayName} 的最终受益所有人 (UBO)",
        "relativeEntitySignatoryAdd": "为 {displayName} 添加签名者",
        "relativeEntitySignatoryEdit": "编辑 {displayName} 的签名人",
        "relativeEntityPowerOfAttorneyAdd": "为 {displayName} 添加签名者",
        "relativeEntityPowerOfAttorneyEdit": "编辑 {displayName} 的签名人"
      },
      "deleteModal": {
        "UBOTitle": "您确定要删除该最终受益人吗？",
        "UBOSubtitle": "您即将删除此最终受益人：{entityName}",
        "signatoryTitle": "您确定删除该签名者吗？",
        "signatorySubtitle": "您将要删除此签名者：{entityName}"
      }
    },
    "companyRelativeEntitySelection": {
      "addUbo": "添加最终受益人 UBO",
      "addUboInformation": "添加最终受益人 (UBO) 信息",
      "addSignatory": "添加签名人",
      "addSignatoryInformation": "添加签名人 (授权书)信息"
    },
    "companyRelativeEntity": {
      "ownership": "所有权",
      "percentageOfOwnership": "所有权百分比",
      "personalInformation": "个人信息",
      "firstName": "名",
      "middleName": "中间名字",
      "lastName": "姓氏",
      "nationalityIsoCode": "国籍",
      "birthDate": "出生日期",
      "cityOfBirth": "出生城市",
      "countryOfBirthIsoCode": "出生国家",
      "contactInformation": "联系信息",
      "addressLine1": "地址",
      "addressLine2": "",
      "zipCode": "邮政编码",
      "city": "城市",
      "residenceCountryIsoCode": "居住国家",
      "mobilePhoneNumber": "电话号码",
      "email": "电子邮件",
      "passportInformation": "护照信息",
      "passportNumber": "护照号",
      "passportExpirationDate": "护照有效期",
      "jobInformation": "职位信息",
      "role": "活动 1/2",
      "activityId": "活动 2/2",
      "workplaceCountryIsoCode": "工作地点所属国",
      "isPoliticallyExposed": "最终受益人（UBO） 是否为政界人士",
      "isDirector": "董事是否在公司架构内？",
      "taxationInformation": "税务信息",
      "taxationCountryIsoCode": "征税国家",
      "tinNumber": "TIN 编号",
      "hasTinNumber": "我没有 TIN 号码",
      "isLinkedToUnitedStates": "您是否和美国有关系？",
      "hasUSPassportOrGreenCard": "您有美国护照或绿卡吗？",
      "hasSpentSubstantialTimeInUS": "您是否曾在美国停留超过 90 天？",
      "isUSResidentForAnyOtherReason": "您在美国拥有房地产吗？",
      "errors": {
        "firstName": "名字是必填项",
        "lastName": "姓氏为必填项",
        "nationalityIsoCode": "国籍为必填项",
        "residenceCountryIsoCode": "国家/地区为必填项",
        "workplaceCountryIsoCode": "工作地点国家/地区为必填项",
        "birthDate": "出生日期为必填项且必须有效",
        "birthDateFuture": "出生日期不能晚于今天",
        "cityOfBirth": "出生城市为必填项",
        "countryOfBirthIsoCode": "出生国家/地区为必填项",
        "addressLine1": "地址为必填项",
        "zipCode": "邮政编码为必填项",
        "city": "城市为必填项",
        "activityId": "活动为必填项",
        "taxationCountryIsoCode": "征税国家为必填项",
        "isPoliticallyExposed": "此字段是必填字段",
        "isDirector": "此字段是必填字段",
        "percentageOfOwnership": "所有权百分比为必填项的",
        "percentageOfOwnershipInteger": "所有权百分比必须是整数",
        "percentageOfOwnershipRange": "所有权百分比必须介于 0 到 100 之间",
        "signature": "签名为必填项",
        "passportNumber": "护照号码为必填项",
        "passportExpirationDate": "护照有效期为必填项并且必须有效",
        "passportExpirationDateOutdated": "该日期必须大于今天的日期",
        "isLinkedToUnitedStates": "此字段是必填字段",
        "hasUSPassportOrGreenCard": "此字段是必填字段",
        "hasSpentSubstantialTimeInUS": "此字段是必填字段",
        "isUSResidentForAnyOtherReason": "此字段是必填字段",
        "mobilePhoneNumber": "电话号码为必填项且必须有效 (i.e. +41XXXXXXXXX)",
        "email": "电子邮件为必填项",
        "emailValid": "电子邮件必须有效",
        "tinNumber": "TIN 号码为必填项"
      }
    },
    "companyTransaction": {
      "title": "{displayName} 每月的平均公司交易量",
      "subtitle": {
        "incomingTransfer": "入账",
        "outgoingTransfer": "出账"
      },
      "averageAmountOfIncomingTransfer": "平均入账金额",
      "averageAmountOfIncomingTransferCurrencyIsoCode": "货币",
      "averageAmountOfOutgoingTransfer": "平均出账金额",
      "averageAmountOfOutgoingTransferCurrencyIsoCode": "货币",
      "numberOfIncomingTransferPerMonth": "转账次数/月",
      "numberOfOutgoingTransferPerMonth": "转账次数/月",
      "errors": {
        "averageAmountOfIncomingTransfer": "平均入账金额为必填项",
        "averageAmountOfIncomingTransferNumber": "平均入账金额必须是数字",
        "averageAmountOfIncomingTransferCurrencyIsoCode": "货币为必填项",
        "averageAmountOfOutgoingTransfer": "平均出账金额为必填项",
        "averageAmountOfOutgoingTransferNumber": "平均出账金额必须是数字",
        "averageAmountOfOutgoingTransferCurrencyIsoCode": "货币为必填项",
        "numberOfIncomingTransferPerMonth": "入账次数为必填项",
        "numberOfIncomingTransferPerMonthInteger": "入账次数必须是整数",
        "numberOfOutgoingTransferPerMonth": "出账次数为必填项",
        "numberOfOutgoingTransferPerMonthInteger": "出账次数必须是整数"
      }
    },
    "companyCounterpartyList": {
      "transactions": "交易",
      "noResults": "没有添加交易。 如有必要，请添加所有涉及的交易对手。",
      "deleteModal": {
        "title": "您确定删除该交易对手吗？",
        "subtitle": "您即将删除此交易对手：{entityName}"
      },
      "listHeaders": {
        "companyName": "交易对手",
        "nationalityIsoCode": "国籍",
        "funds": "资金",
        "goods": "商品",
        "from": "原产地",
        "to": "目的地",
        "hsCode": "HS Code",
        "operationType": "操作类型",
        "cashFlowType": "现金流类型",
        "yearlyValuationAmount": "年营业额",
        "fundTransferFromCountryIsoCode": "资金来自",
        "fundTransferToCountryIsoCode": "资金用于",
        "commodityFromCountryIsoCode": "商品产地",
        "commodityToCountryIsoCode": "货物目的地"
      }
    },
    "companyCounterpartyEdit": {
      "title": "交易对手信息",
      "companyName": "交易对手名称",
      "nationalityIsoCode": "交易对手国籍",
      "fundTransferFromCountry": "资金转自",
      "fundTransferFromSwitzerland": "CIM Banque",
      "fundTransferToCountry": "资金转至",
      "fundTransferToSwitzerland": "CIM Banque",
      "commodityFromCountryIsoCode": "商品原产地",
      "commodityToCountryIsoCode": "货物目的地",
      "productType": "商品类型",
      "hsCodeChapter": "HS Code 大类",
      "hsCode": "HS Code",
      "operationType": "操作类型",
      "cashFlowType": "现金流类型",
      "yearlyValuationAmount": "年营业额",
      "yearlyValuationCurrencyIsoCode": "货币",
      "bankName": "银行名",
      "errors": {
        "companyName": "交易对手名称为必填项",
        "nationalityIsoCode": "国籍为必填项",
        "fundTransferFromCountryIsoCode": "资金来源为必填项",
        "fundTransferToCountryIsoCode": "资金目的地为必填项",
        "commodityFromCountryIsoCode": "商品原产地为必填项",
        "commodityToCountryIsoCode": "货物目的地为必填项",
        "productType": "商品类型为必填项",
        "operationType": "操作类型为必填项",
        "cashFlowType": "现金流量类型为必填项",
        "yearlyValuationAmount": "年营业额为必填项",
        "yearlyValuationAmountNumber": "年营业额必须是数字",
        "yearlyValuationCurrencyIsoCode": "年营业额货币为必填项",
        "bankName": "银行名称为必填项"
      }
    },
    "underReview": {
      "title": "感谢您对 CIM 银行的关注。",
      "message": "您的帐户正在接受审核，我们会尽快与您联系。 如果您对请求有任何疑问，请随时<a href='https://www.cimbanque.com/en/the-bank/contact-us/' target='_blank'>与我们联系</a>"
    },
    "refused": {
      "title": "感谢您对 CIM 银行的关注。",
      "message": "不过，我们很遗憾地通知您，我们无法继续处理您的开户请求。"
    },
    "initialDeposit": {
      "title": "您的初始存款",
      "activateAccount": "要激活您的帐户并接收信用卡，请在 15 天内从<u>您的实际个人银行帐户<u>存入初始存款（最低 欧元/瑞士法郎/美元 5'000）。",
      "activateAccountCorporate": "要激活您的帐户并接收信用卡，请在 15 天内从<u>您的实际银行账户<u>存入初始存款（最低 欧元/瑞士法郎/美元 10'000）。",
      "notice": "请注意，如果您未在 15 天内为您的账户注入资金，该账户将自动关闭。"
    },
    "ibanTempo": {
      "name": "姓名",
      "tempIban": "临时 IBAN 号码",
      "swift": "SWIFT代码",
      "bankAddress": "银行地址",
      "bank": {
        "name": "CIM BANQUE",
        "addressLine1": "RUE MERLE D'AUBIGNE 16",
        "addressLine2": "GENEVA 1211 - Switzerland",
        "swift": "CIMMCHGG"
      }
    }
  }
}
